import { render } from "./card-border-orange.vue?vue&type=template&id=0f6ee549&scoped=true"
import script from "./card-border-orange.vue?vue&type=script&lang=js"
export * from "./card-border-orange.vue?vue&type=script&lang=js"

import "./card-border-orange.vue?vue&type=style&index=0&id=0f6ee549&scoped=true&lang=less"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6ee549"]])

export default __exports__